/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_S5Inputs */

const en_mk_tut_ws_s5 = /** @type {(inputs: Mk_Tut_Ws_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The main assistant, **Bystep Agent**, always comes along in addition to the division agents. It is the one to talk to when you need an answer that spans divisions.`)
};

const id_mk_tut_ws_s5 = /** @type {(inputs: Mk_Tut_Ws_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asisten utama bernama **Bystep Agent** selalu ikut, di luar agen divisi. Ia yang Anda ajak bicara kalau butuh jawaban lintas divisi.`)
};

/**
* | output |
* | --- |
* | "The main assistant, **Bystep Agent**, always comes along in addition to the division agents. It is the one to talk to when you need an answer that spans divi..." |
*
* @param {Mk_Tut_Ws_S5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_s5 = /** @type {((inputs?: Mk_Tut_Ws_S5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_S5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_s5(inputs)
	return en_mk_tut_ws_s5(inputs)
});